// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeClaimApi = class EdgeClaimApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async claimMedicalClaimSearch(claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest, xProgramId) {
        const _url_ = '/edge/claim/v1/Claim/medicalClaimSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest' is not null or undefined
        if (claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest === null || claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest was null or undefined when calling claimMedicalClaimSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest, "ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async claimPharmacyClaimSearch(claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest, xProgramId) {
        const _url_ = '/edge/claim/v1/Claim/pharmacyClaimSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest' is not null or undefined
        if (claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest === null || claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest was null or undefined when calling claimPharmacyClaimSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest, "ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param iPlaceOrderRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async claimV1PlaceOrder(iPlaceOrderRequestModel, xProgramId) {
        const _url_ = '/edge/claim/v1/PlaceOrder';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iPlaceOrderRequestModel' is not null or undefined
        if (iPlaceOrderRequestModel === null || iPlaceOrderRequestModel === undefined) {
            throw new Error('Required parameter iPlaceOrderRequestModel was null or undefined when calling claimV1PlaceOrder.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iPlaceOrderRequestModel, "IPlaceOrderRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1PlaceOrderDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param claimAdjudicationRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async clientAdjudicationThirdParty(claimAdjudicationRequest, xProgramId) {
        const _url_ = '/edge/claim/v1/adjudication/thirdParty';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'claimAdjudicationRequest' is not null or undefined
        if (claimAdjudicationRequest === null || claimAdjudicationRequest === undefined) {
            throw new Error('Required parameter claimAdjudicationRequest was null or undefined when calling clientAdjudicationThirdParty.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimAdjudicationRequest, "ClaimAdjudicationRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimAdjudicationResponse");
        }
        return response;
    }
};
EdgeClaimApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeClaimApi);
export { EdgeClaimApi };
//# sourceMappingURL=edgeClaimApi.js.map